module.exports = {
  SendAGiftComponentEvents: {
    SendAGiftEntry: {
      code: 'SendAGiftEntry',
      events: {
        PageLoaded: {
          description: 'Triggered when gifting page is loaded',
          eventHub: {
            code: 'PageLoaded',
            action: 'Gifting_Subscriber_Welcome_page',
            dataKeys: []
          },
          ga: {
            action: 'SG - Entry - Page loaded'
          }
        },
        CardClicked: {
          description: 'Triggered when the user clicks card',
          eventHub: {
            code: 'CardClicked',
            action: 'Gifting_Subscriber_Welcome_page_Card',
            dataKeys: ['button']
          },
          ga: {
            action: 'SG - Entry - Clicked Card'
          }
        },
        CreateGiftLinkClicked: {
          description: 'Triggered when the user clicks the "Create gift link" button.',
          eventHub: {
            code: 'CreateGiftLinkClicked',
            action: 'Gifting_Subscriber_Welcome_page_CreateGiftLink',
            dataKeys: ['button']
          },
          ga: {
            action: 'SG - Entry - Clicked Create gift link'
          }
        }
      }
    },
    SendAGiftSelectPlan: {
      code: 'SendAGiftSelectPlan',
      events: {
        PageLoaded: {
          description: 'Triggered when select plan page is loaded.',
          eventHub: {
            code: 'PageLoaded',
            action: 'Gifting_Subscriber_Select_Plan',
            dataKeys: []
          },
          ga: {
            action: 'SG - Select Plan - Page loaded'
          }
        },
        ContinueClicked: {
          description: 'Triggered when the user clicks the "Continue" button.',
          eventHub: {
            code: 'ContinueClicked',
            action: 'Gifting_Subscriber_Select_Plan_Continue',
            dataKeys: ['button']
          },
          ga: {
            action: 'SG - Select Plan - Clicked continue'
          }
        },
        BackClicked: {
          description: 'Triggered when the user clicks the "Back" button.',
          eventHub: {
            code: 'BackClicked',
            action: 'Gifting_Subscriber_Select_Plan_Back',
            dataKeys: ['button']
          },
          ga: {
            action: 'SG - Select Plan - Clicked back'
          }
        }
      }
    },
    SendAGiftSelectBene: {
      code: 'SendAGiftSelectBene',
      events: {
        PageLoaded: {
          description: 'Triggered when select bene page is loaded.',
          eventHub: {
            code: 'PageLoaded',
            action: 'Gifting_Subscriber_Select_Bene',
            dataKeys: []
          },
          ga: {
            action: 'SG - Select Bene - Page loaded'
          }
        },
        ContinueClicked: {
          description: 'Triggered when the user clicks the "Create gift page" button.',
          eventHub: {
            code: 'ContinueClicked',
            action: 'Gifting_Subscriber_Select_Bene_Continue',
            dataKeys: ['button']
          },
          ga: {
            action: 'SG - Select Bene - Clicked continue'
          }
        },
        BackClicked: {
          description: 'Triggered when the user clicks the "Back" button.',
          eventHub: {
            code: 'BackClicked',
            action: 'Gifting_Subscriber_Select_Bene_Back',
            dataKeys: ['button']
          },
          ga: {
            action: 'SG - Select Bene - Clicked back'
          }
        },
        AddPhotoClicked: {
          description: 'Triggered when the user clicks the "Add a photo" button.',
          eventHub: {
            code: 'AddPhotoClicked',
            action: 'Gifting_Subscriber_Select_Bene_Add_Photo',
            dataKeys: ['button']
          },
          ga: {
            action: 'SG - Select Bene - Clicked Add photo'
          }
        },
        PhotoConsent: {
          description: 'Triggered when the user selects/unselects the image switch.',
          eventHub: {
            code: 'PhotoConsent',
            action: 'Gifting_Subscriber_Select_Bene_Photo_Consent',
            dataKeys: ['photoConsent']
          },
          ga: {
            action: 'SG - Select Bene - Toggled photo consent to [$.photoConsent]'
          }
        }
      }
    },
    SendAGiftBeneEmail: {
      code: 'SendAGiftBeneEmail',
      events: {
        PageLoaded: {
          description: 'Triggered when bene email page is loaded',
          eventHub: {
            code: 'PageLoaded',
            action: 'Gifting_Subscriber_Bene_Email',
            dataKeys: []
          },
          ga: {
            action: 'SG - Bene Email - Page loaded'
          }
        },
        ContinueClicked: {
          description: 'Triggered when the user clicks the "Continue" button.',
          eventHub: {
            code: 'ContinueClicked',
            action: 'Gifting_Subscriber_Bene_Email_Continue',
            dataKeys: ['button']
          },
          ga: {
            action: 'SG - Bene Email - Clicked continue'
          }
        },
        BackClicked: {
          description: 'Triggered when the user clicks the "Back" button.',
          eventHub: {
            code: 'BackClicked',
            action: 'Gifting_Subscriber_Bene_Email_Back',
            dataKeys: ['button']
          },
          ga: {
            action: 'SG - Bene Email - Clicked back'
          }
        },
        SkipClicked: {
          description: 'Triggered when the user clicks the "Skip this step" button.',
          eventHub: {
            code: 'SkipClicked',
            action: 'Gifting_Subscriber_Bene_Email_Skip',
            dataKeys: ['button']
          },
          ga: {
            action: 'SG - Bene Email - Clicked skip'
          }
        }
      }
    },
    SendAGiftShare: {
      code: 'SendAGiftShare',
      events: {
        PageLoaded: {
          description: 'Triggered when gifting share page is loaded.',
          eventHub: {
            code: 'PageLoaded',
            action: 'Gifting_Subscriber_Share',
            dataKeys: []
          },
          ga: {
            action: 'SG - Share - Page loaded'
          }
        },
        BackClicked: {
          description: 'Triggered when the user clicks the "Back" button.',
          eventHub: {
            code: 'BackClicked',
            action: 'Gifting_Subscriber_Share_Back',
            dataKeys: []
          },
          ga: {
            action: 'SG - Share - Clicked back'
          }
        },
        MobileShare: {
          description: 'Triggered when the user clicks the "Share" button.',
          eventHub: {
            code: 'MobileShare',
            action: 'Gifting_Subscriber_Share_Mobile_Share',
            dataKeys: ['button']
          },
          ga: {
            action: 'SG - Share - Clicked mobile share'
          }
        },
        CopyLinkClicked: {
          description: 'Triggered when the user clicks the "Copy link" button.',
          eventHub: {
            code: 'CopyLinkClicked',
            action: 'Gifting_Subscriber_Share_Copy_Link',
            dataKeys: ['button']
          },
          ga: {
            action: 'SG - Share - Clicked copy link'
          }
        },
        DoneClicked: {
          description: 'Triggered when the user clicks the "Done" button.',
          eventHub: {
            code: 'DoneClicked',
            action: 'Gifting_Subscriber_Share_Done',
            dataKeys: ['button']
          },
          ga: {
            action: 'SG - Share - Clicked done'
          }
        }
      }
    }
  }
};
